import React from 'react';
import { sort } from 'utils/sort';
import Criterion from './Criterion';

const CriteriaList = ({ data }) => {
  const sortedCriteria = sort(data.criteriaRatings, 'name');
  return (
    <div className="CriteriaList">
      {sortedCriteria.map(criterion => (
        <Criterion
          criterion={criterion}
          ratingOptions={data.ratingOptions}
          preview={data.preview}
          key={`criteriaRatingId-${data.id ? data.id : 0}-criterionId-${
            criterion.id
          }`}
          answerId={data.id}
        />
      ))}
    </div>
  );
};

export default CriteriaList;
